import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ModalBody } from "reactstrap";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import "react-image-gallery/styles/image-gallery.css";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import {
  getContestProposalbyid,
  likeContest,
  postModelComment,
} from "../../../../../redux/contest/action";
import ModelCommentLIst from "./Comments/ModelCommentLIst.";
import RateTOUSER from "../../../../Common/CustomeLabel/RateTOUSER";
import CustomRatingLabel from "../../../../Common/CustomeLabel/CustomRatingLabel";
import { today } from "../../../../../CloudStorage/CommonFunction";
import CustomeLike from "../../../../Common/CustomeLabel/CustomeLike";
import ProfilePic from "../../../../../assests/imgs/Profileplaceholder.svg";
import ReactImageGalleryCompoment from "./ReactImageGalleryCompoment";

const preprocessImages = async (files) => {
  const processedImages = await Promise.all(
    files.map(async (file) => {
      return {
        original: file?.file,
        thumbnail: file?.file,
      };
    }),
  );
  return processedImages;
};

export default function ContestModel({ modal, setModal, values, posts }) {
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const navigate = useNavigate();
  const [like, setLike] = useState(0);
  const [review, setReview] = useState(0);
  const [loading, setLoading] = useState(false);
  const [id, setID] = useState(false);
  const dispatch = useDispatch();
  const [images, setImages] = useState([]);

  const propsaldata = useSelector(
    ({ contest: { getcontestpropsalbyid } }) => getcontestpropsalbyid,
  );

  useEffect(() => {
    dispatch(getContestProposalbyid(values?.id));
  }, [values?.id]);

  useEffect(() => {
    setLike(propsaldata?.liked || 0);
    setReview(propsaldata?.rating || 0);
  }, [propsaldata]);

  const profile = useSelector(({ profile: { profiledata } }) => profiledata);

  // const images = Array.isArray(propsaldata.files) && propsaldata?.files?.map(file => ({
  //     original: file.file,
  //     thumbnail: file.file
  // })) || [];

  useEffect(() => {
    if (propsaldata) {
      setLike(propsaldata?.liked || 0);
      setReview(propsaldata?.rating || 0);
      if (Array.isArray(propsaldata.files)) {
        preprocessImages(propsaldata.files).then(setImages);
      }
    }
  }, [propsaldata]);

  const formik = useFormik({
    initialValues: {
      comment: "",
    },
    validationSchema: Yup.object({
      comment: Yup.string()
        .max(500, "Must be 500 characters or less")
        .required("Required"),
    }),
    onSubmit: (values, { resetForm }) => {
      submitform(values, resetForm);
      formik.setFieldValue("comment", "");
      resetForm();
    },
  });

  const submitform = (values1, resetForm) => {
    const data = {
      message: values1.comment,
      proposal_id: propsaldata?.id,
      type: 3,
      post_id: posts?.id,
    };
    dispatch(postModelComment(data, setLoading));
    resetForm();
    setID(id + 1);
  };

  const likethisContest = () => {
    if (like == "1") {
      setLike(-1);
    } else {
      setLike(1);
    }
    const data = {
      proposal_id: propsaldata?.id,
      type: 1,
      post_id: posts?.id,
    };
    dispatch(likeContest(data, setLoading));
  };

  const AwardContest = (id) => {
    const data = {
      id: propsaldata?.id,
      type: 2,
      status: 12,
    };
    // dispatch(awardContest(data, setLoading));

    comformhireExpert(propsaldata?.id)
  };
  const comformhireExpert = (id) => {
    navigate(`/${lan}/contestcontract/${id}`, { state: { owner: true } });
  };

  const islastdate = () => {
    return posts?.last_date < today;
  };

  return (
    <div className="rent-product">
      <button onClick={() => setModal(false)} className="btn d-block ml-auto" >
        <img
          src={`${CloudStorage.cloudurl}/Assets/Images/common/x-circle.svg`}
          alt=""
        />
      </button>
      <ModalBody>
        <div className="modal-popup">
          <div className="modal-image">
            <div className="row justify-content-between">
              <div className="col-lg-7 col-md-5 popup-right">
                <div className="star-sec">
                  {posts.is_mine == 1 ? (
                    <div className="popup-cont">
                      <RateTOUSER
                        posts={posts}
                        values={propsaldata}
                        rating={review}
                      />
                    </div>
                  ) : (
                    <CustomRatingLabel rating={review} />
                  )}
                  <CustomeLike posts={posts} like={like} setLike={setLike} values={propsaldata} />
                </div>
                <ReactImageGalleryCompoment images={images} />
                <div className="sub-image">
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/contestdetails/100/contest-img.png`}
                    alt=""
                  />
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/contestdetails/100/contest-img.png`}
                    alt=""
                  />
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/contestdetails/100/contest-img.png`}
                    alt=""
                  />
                </div>
              </div>
              <div className="col-lg-4 col-md-7 popup-left">
                <div className="entry-label">
                  <img
                    src={propsaldata?.profile_image ? propsaldata?.profile_image : ProfilePic}
                    className="label-img"
                    alt=""
                  />
                  <div>
                    <p>
                      By<span>{propsaldata?.first_name} {propsaldata?.last_name}</span>
                    </p>
                    <h6>Entry no. : #{propsaldata?.entry_number} </h6>
                    <h6>Licensed Content
                      : <p>{propsaldata?.licensed == 1 ? 'This entry is entirely my own.' : 'This entry contains elements I did not create.'} </p></h6>
                  </div>
                </div>
                <div className="popup-cont">
                  <h5>{propsaldata?.title} </h5>
                  <p>{propsaldata?.message}</p>

                  {(posts.is_mine == 1 && posts.status == 11) &&
                    propsaldata?.status == 11 &&
                    islastdate() &&
                    (
                      <button onClick={() => AwardContest()} className="">
                        Award Contest
                      </button>
                    )}
                </div>

                {(posts.is_mine == 1 || propsaldata?.is_mine == 1) && (
                  <>
                    <div className="last-popupsec">
                      <form onSubmit={formik.handleSubmit} className="w-100">
                        <div className="last-comment-sec">
                          <img src={profile?.profile_image ? profile?.profile_image : ProfilePic} alt="" />
                          <input
                            type="text"
                            placeholder="Write a comment"
                            className="form-control"
                            id="comment"
                            name="comment"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.comment}
                          />
                        </div>
                        {formik.touched.comment && formik.errors.comment ? (
                          <div style={{ color: "red" }} className="error mt-2">
                            {formik.errors.comment}
                          </div>
                        ) : null}
                        <div className="send-btn">
                          <button type="submit" className="btn">
                            Send
                          </button>
                        </div>
                      </form>
                    </div>
                    <ModelCommentLIst id={id} item={values} />
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </ModalBody>
    </div>
  );
}
